// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"5482855e","239":"60c98941","455":"66dfeae0","488":"bbe4cbe7"}[chunkId] + ".chunk.js";
};